module.exports = "<select class=\"form-control\" [(ngModel)]=\"selectedID\" (change)=\"onDataChanged($event.target.value)\">\n  <option [ngValue]=\"null\">Select</option>\n  <option *ngFor=\"let agency of agencies\" [ngValue]=\"agency.id\">{{agency.name}} ({{agency.status}})</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/shared/agency-selection/agency-selection.component.html
// module id = ../../../../../src/app/shared/agency-selection/agency-selection.component.html
// module chunks = main